import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import { Environment, getAppEnvironment, datadogConfig, appConfig } from '../config';
import { getOrCreateSessionId } from '@utils/sessionId';

const environment = getAppEnvironment();

const shouldIgnoreErrorForDatadog = (msg: string) => {
  return msg.includes('useResizeContainer');
};

export const initDatadog = () => {
  initDatadogLogs();
  initDatadogRum();
  if (environment === Environment.Prod) {
    datadogRum.startSessionReplayRecording();
  }
};

const initDatadogLogs = () => {
  if (!datadogConfig.logsClientToken) return;
  if (datadogLogs.getInitConfiguration()) return;
  datadogLogs.init({
    clientToken: datadogConfig.logsClientToken,
    service: datadogConfig.service,
    env: environment,
    version: appConfig.version,
    sampleRate: 100,
    forwardErrorsToLogs: true,
    beforeSend: (event: any) => {
      // Filter out error events matching shouldIgnoreErrorForDatadog
      if (shouldIgnoreErrorForDatadog(event?.message || '')) {
        return false;
      }

      return true;
    },
  });
};

const initDatadogRum = () => {
  if (!datadogConfig.rumApplicationId) return;
  if (!datadogConfig.rumClientToken) return;
  if (datadogRum.getInitConfiguration()) return;
  datadogRum.init({
    applicationId: datadogConfig.rumApplicationId,
    clientToken: datadogConfig.rumClientToken,
    site: datadogConfig.site,
    service: datadogConfig.service,
    env: environment,
    version: appConfig.version,
    allowedTracingOrigins: ['/https:\\/\\/.*\\.mylioinsurance\\.com/'],
    sampleRate: 100,
    sessionReplaySampleRate: 100,
    trackResources: true,
    trackLongTasks: true,
    trackInteractions: true,
    beforeSend: (event: any) => {
      // Filter out error events matching shouldIgnoreErrorForDatadog

      if (shouldIgnoreErrorForDatadog(event?.message || '')) {
        return false;
      }

      return true;
    },
  });
};

export const setDatadogRumUser = (rumUser: Parameters<typeof datadogRum.setUser>[0]) => {
  const sessionId = getOrCreateSessionId();
  datadogLogs.setGlobalContext({
    user: {
      id: rumUser.id,
      name: rumUser.name,
      email: rumUser.email,
    },
    ...(sessionId && { sessionId }),
  });
  datadogRum.setUser({
    ...rumUser,
    ...(sessionId && { sessionId }),
  });
};
